import {useTranslation} from 'react-i18next';

import './styles';
import {ILimitsFeesResponse} from '@/dataSource/src/api/payment-link/v2/models';
import {PaymentMethodType} from '@/dataSource/src/api/payment-link/v2/types';

import {useActions} from './useActions';

type PaymentLinkV2LimitFeeBoxProps = {
  receiverName?: string;
  receiverAmount?: number;
  selectedMethod?: PaymentMethodType;
  limitsFees: ILimitsFeesResponse | undefined;
};

export default function PaymentLinkV2LimitFeeBox({
  receiverName,
  receiverAmount,
  selectedMethod,
  limitsFees,
}: PaymentLinkV2LimitFeeBoxProps) {
  const {t} = useTranslation();

  const {formattedReceive, formattedFee, formattedTotal} = useActions({
    receiverAmount,
    selectedMethod,
    limitsFees,
  });

  if (!formattedReceive || !formattedFee || !formattedTotal) return null;

  return (
    <section className="fee-box">
      <div className="fee-box__inner">
        <div className="fee-row fee-row--receiver">
          <span className="fee-label">
            {receiverName} {t('payment_link_v2.receives')}
          </span>
          <span className="fee-value">${formattedReceive}</span>
        </div>

        <div className="fee-row">
          <span className="fee-label">{t('payment_link_v2.network_fee')}</span>
          <span className="fee-value">${formattedFee}</span>
        </div>

        <hr className="fee-separator" />

        <div className="fee-row">
          <span className="fee-label">{t('payment_link_v2.you_pay')}</span>
          <span className="fee-total">${formattedTotal}</span>
        </div>
      </div>
    </section>
  );
}
